var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m6.263 12.914.39.876a1.475 1.475 0 0 0 2.696 0l.39-.876a1.62 1.62 0 0 1 1.647-.949l.953.102a1.474 1.474 0 0 0 1.348-2.335l-.564-.776A1.62 1.62 0 0 1 12.816 8c0-.342.108-.676.31-.953l.564-.775a1.473 1.473 0 0 0-.524-2.183 1.48 1.48 0 0 0-.824-.152l-.953.102a1.617 1.617 0 0 1-1.647-.953l-.393-.876a1.475 1.475 0 0 0-2.696 0l-.39.876a1.62 1.62 0 0 1-1.646.953l-.957-.102a1.475 1.475 0 0 0-1.348 2.335l.565.775a1.62 1.62 0 0 1 0 1.906l-.565.775a1.474 1.474 0 0 0 1.348 2.335l.954-.102a1.62 1.62 0 0 1 1.65.953"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })));
};
export default SvgSettings;